import * as actions from "../global/actionTypes";

const initState = {
  jobId: undefined,
  isFetching: false,
  fleetsCount: 0,
  visitsCount: 0,
  data: {},
};

export default function (state = initState, action = {}) {
  switch (action.type) {
    case actions.FETCH_JOB_REQUEST:
      return {
        jobId: action.jobId,
        isFetching: true,
        fleetsCount: 0,
        visitsCount: 0,
        data: {},
      };
    case actions.FETCH_JOB_FAILURE:
      return {
        jobId: action.jobId,
        isFetching: false,
        fleetsCount: 0,
        visitsCount: 0,
        data: {},
      };
    case actions.FETCH_JOB_SUCCESS: {
      const data = action.response.data || {};

      return {
        jobId: action.jobId,
        isFetching: false,
        data: data,
        fleetsCount: data.fleet || 0,
        visitsCount: data.visits || 0,
      };
    }
    default:
      return state;
  }
}
